import Vue from 'vue'
import {mapActions} from 'vuex'
import {pregao} from '@/commons/constants'

Vue.mixin({
    methods: {
        ...mapActions(['buscarTokenAcessoPregao']),
        async acessarPregao(licitacao) {
            let url = null;
            if (licitacao.linkAcessoExterno) {
                url = licitacao.linkAcessoExterno
            } else {
                if (!this.podeAcessarPregao(licitacao)) {
                    this.mostrarNotificacaoErro('Não é possível acessar antes da Data/Hora de abertura.')
                    return
                }
                const usuarioId = this.$store.state.loki.user.id
                const data = await this.buscarTokenAcessoPregao({licitacaoId: licitacao.id, usuarioId})
                const uriPregao = pregao.URL_ACESSO + '?data=' + data
                const hostname = window.location.hostname === '172.17.0.1' ? window.location.hostname + ':8090' : window.location.hostname
                url = `${window.location.protocol}//${hostname}${uriPregao}`
            }

            if(url == '#'){
                this.mostrarNotificacaoErro('Opção não disponível.')
                return
            }

            window.location = url
        },
        async acessarPregaoProposta(licitacao) {
            let url = null;
            if (licitacao.linkAcessoExternoLicitante) {
                url = licitacao.linkAcessoExternoLicitante
            }
            window.location = url
        },
        podeAcessarPregao(licitacao) {
            if (this.isFornecedor && !licitacao.podeAcessar) {
                return false
            }
            return true
        }
    }
})
